const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  isMacOS: state => state.env.isMacOS,
  isAndroid: state => state.env.isAndroid,
  isWX: state => state.env.isWX,
  isMobile: state => state.env.isMobile,
  isMiniProgram: state => state.env.isMiniProgram,
  wxSignUrl: state => state.env.wxSignUrl,
  isLoading: state => state.env.isLoading,
  isDebug: state => state.env.isDebug,
  surveyCode: state => state.user.surveyCode,
  popupSetting: state => state.user.popupSetting,
  showPopup: state => state.user.showPopup,
  tokenExpired: state => state.env.isWX ? 7 : 0.33,
  language: state => state.env.language,
  smsCount: state => state.env.smsCount,
  scroll: state => state.scroll.scroll,
  offsetWidth: state => state.env.offsetWidth,
  offsetHeight: state => state.env.offsetHeight
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js